/* eslint-disable */
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

/*import url and gateway methods */
import { getData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

import CrmLeadInformationCommonHeader from "../../common/CrmLeadInformationCommonHeader";
import CrmLeadInformationLeftPanel from "../LefPanel/CrmLeadInformationLeftPanel";

import { assetImages } from "constants";

import AlertNotification from "components/Common/AlertNotification/AlertNotification";

import NoteSection from "components/Common/NoteComponent/NoteSection";
import HistoryCard from "components/Common/HistoryCard/HistoryCard";

const CrmLeadInformationBody = () => {
  const params = useParams();

  const moduleAccess = localStorage.getItem("moduleaccess");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const token = localStorage.getItem("token");

  const { t } = useTranslation(); //for translation

  const [leadLoading, setLeadLoading] = useState(true); //for loading the lead details
  const [leadName, setleadName] = useState("");
  const [leadImage, setleadImage] = useState("");
  const [isAuthenticatedUser, setisAuthenticatedUser] = useState(false);

  const [noteAccessUserList, setnoteAccessUserList] = useState([]);

  const [leadHistory, setLeadHistory] = useState([]);

  //alert requirements
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  //function for get lead history of modified lead
  const getLeadHistory = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_LEAD_HISTORY +
        `?leadid=${params.id}`;

      const response = await getData(requestUrl);

      console.log("response in lead history------>", response);

      if (response.status) {
        setLeadHistory(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  useEffect(() => {
    if (params.id) {
      getLeadHistory();
    }
  }, [params.id]);

  if (
    userInfo.role.slug === "ADMIN" ||
    userInfo.role.slug === "SUPER_ADMIN" ||
    (moduleAccess.includes("MOD_CRM") && moduleAccess.includes("MOD_LEAD"))
  ) {
    return (
      <div id="content_wrapper">
        <section className="crm-wrapper bg-white">
          {/* ------ lead information common header ------ */}
          <CrmLeadInformationCommonHeader
            moduleName="leadinformation"
            leadName={leadName}
            leadImage={leadImage}
            isAuthenticatedUser={isAuthenticatedUser}
            leadLoading={leadLoading}
          />
          {/* ------ lead information section start ------ */}
          <div className="crm-info-container py-4 py-md-5">
            <div className="container-fluid px-lg-5">
              <div className="row">
                {/* ------- lead information left panel start ------ */}
                <div className="col-lg-8 mb-4 mb-lg-0">
                  <CrmLeadInformationLeftPanel
                    setleadName={setleadName}
                    setleadImage={setleadImage}
                    setisValidUser={setisAuthenticatedUser}
                    setShowAlert={setShowAlert}
                    setAlertMessage={setAlertMessage}
                    setMessageType={setMessageType}
                    setnoteAccessUserList={setnoteAccessUserList}
                    setLeadLoading={setLeadLoading}
                  />
                </div>
                {/* ------- lead information left panel end ------ */}

                {/* ------- lead information right panel start ------ */}
                <div className="col-lg-4">
                  <NoteSection
                    noteAccessUserList={noteAccessUserList}
                    leadId={params.id}
                    setShowAlert={setShowAlert}
                    setAlertMessage={setAlertMessage}
                    setMessageType={setMessageType}
                  />

                  <div className="mt-4 bg-white border border-gray-300 rounded-15 shadow-lg overflow-hidden">
                    <div
                      className="px-4 py-3 border-bottom border-gray-300"
                      style={{
                        background:
                          "linear-gradient(135deg, rgba(238, 82, 60, 0.1) 0%, rgba(255, 255, 255, 0.95) 100%)",
                      }}
                    >
                      <div className="d-flex align-items-center gap-3">
                        <div
                          className="p-2 bg-primary rounded-circle d-flex align-items-center justify-content-center"
                          style={{ width: "40px", height: "40px" }}
                        >
                          <span className="material-symbols-outlined text-white fs-md">
                            history
                          </span>
                        </div>
                        <div>
                          <h4 className="fw-bold mb-1 text-dark">
                            {t("History")}
                          </h4>
                          <p className="fs-sm text-muted mb-0">
                            {t("Recent changes and updates")}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="p-4">
                      {leadHistory.length > 0 ? (
                        <div className="notes-container">
                          {leadHistory.map((historyItem, index) => (
                            <HistoryCard
                              historyItem={historyItem}
                              t={t}
                              key={index}
                            />
                          ))}
                        </div>
                      ) : (
                        <div className="text-center py-5">
                          <div
                            className="p-4 bg-light rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                            style={{ width: "80px", height: "80px" }}
                          >
                            <span
                              className="material-symbols-outlined text-muted"
                              style={{ fontSize: "2rem" }}
                            >
                              history
                            </span>
                          </div>
                          <h6 className="fw-bold text-muted mb-2">
                            {t("No History Yet")}
                          </h6>
                          <p className="text-muted mb-0">
                            {t("Changes will appear here")}
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                {/* ------- lead information right panel end ------ */}
              </div>
            </div>
          </div>
          {/* ------ lead information section end ------ */}

          {showAlert && (
            <AlertNotification
              showAlert={showAlert}
              message={alertMessage}
              alertType={messageType}
              onClose={onAlertClose}
            />
          )}
        </section>
      </div>
    );
  } else {
    return (
      <div className="empty_access text-center">
        <div className="empty_pic mb-4">
          {" "}
          <img src={assetImages.emptyVector} alt="" />
        </div>
        <div className="empty_text">
          <p className="fs-lg text-gray fw-semibold mb-4">
            {t("Sorry....! You don't have privilege to see this content")}
          </p>
        </div>
      </div>
    );
  }
};

export default CrmLeadInformationBody;
